/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ContactPersonToContractV1Dto } from '../models/ContactPersonToContractV1Dto';
import type { CreateContactPersonToContractV1Dto } from '../models/CreateContactPersonToContractV1Dto';
import type { DeleteManyRequestV1 } from '../models/DeleteManyRequestV1';
import type { DeleteManyResultV1 } from '../models/DeleteManyResultV1';
import type { PatchContactPersonToContractV1Dto } from '../models/PatchContactPersonToContractV1Dto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ContactPersonToContractsService {
  /**
   * @param requestBody
   * @returns ContactPersonToContractV1Dto create entity
   * @throws ApiError
   */
  public static contactPersonToContractControllerV1CreateV1(
    requestBody: CreateContactPersonToContractV1Dto,
  ): CancelablePromise<ContactPersonToContractV1Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/contact-person-to-contracts',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @returns ContactPersonToContractV1Dto a entity list
   * @throws ApiError
   */
  public static contactPersonToContractControllerV1FindAllV1(): CancelablePromise<
    Array<ContactPersonToContractV1Dto>
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/contact-person-to-contracts',
      errors: {
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param requestBody
   * @returns DeleteManyResultV1 batch delete result
   * @throws ApiError
   */
  public static contactPersonToContractControllerV1RemoveManyV1(
    requestBody: DeleteManyRequestV1,
  ): CancelablePromise<DeleteManyResultV1> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/contact-person-to-contracts',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param id contactPersonToContractId
   * @returns ContactPersonToContractV1Dto the entity
   * @throws ApiError
   */
  public static contactPersonToContractControllerV1FindOneV1(
    id: string,
  ): CancelablePromise<ContactPersonToContractV1Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/contact-person-to-contracts/{id}',
      path: {
        id: id,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param id contactPersonToContractId
   * @param requestBody
   * @returns ContactPersonToContractV1Dto the update entity
   * @throws ApiError
   */
  public static contactPersonToContractControllerV1UpdatePartialV1(
    id: string,
    requestBody: PatchContactPersonToContractV1Dto,
  ): CancelablePromise<ContactPersonToContractV1Dto> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/v1/contact-person-to-contracts/{id}',
      path: {
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
  /**
   * @param id contactPersonToContractId
   * @returns ContactPersonToContractV1Dto the entity
   * @throws ApiError
   */
  public static contactPersonToContractControllerV1RemoveOneV1(
    id: string,
  ): CancelablePromise<ContactPersonToContractV1Dto> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/contact-person-to-contracts/{id}',
      path: {
        id: id,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
}
